import React, { useState, useEffect } from 'react';
import { Plus, Edit2, Trash2 } from 'lucide-react';
import Modal from '../components/Modal';
import './FormPage.css';
import { API_BASE_URL } from '../global';
import { showAlert, showConfirm } from '../components/AlertPopup';

export default function Categories() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [formData, setFormData] = useState({ id: null, categoria_id: '', categoria_nome: '', categoria_tipo: '', categoria_status: 'Ativo' });

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch(`${API_BASE_URL}/categorias.php`);
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error('Erro ao buscar categorias:', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const method = formData.id ? 'PUT' : 'POST';
    
    try {
      const response = await fetch(`${API_BASE_URL}/categorias.php`, {
        method,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });
      const result = await response.json();
      if (result.success) {
        setIsModalOpen(false);
        fetchCategories();
      } else {
        showAlert('Aviso','Erro ao salvar categoria');
      }
    } catch (error) {
      console.error('Erro:', error);
    }
  };

  const handleEdit = (cat) => {
    setFormData({ 
      id: cat.id, 
      categoria_id: cat.categoria_id, 
      categoria_nome: cat.categoria_nome, 
      categoria_tipo: cat.categoria_tipo, 
      categoria_status: cat.categoria_status 
    });
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    const confirmed = await showConfirm('Confirmação', 'Tem certeza que deseja excluir esta categoria?');
    if (!confirmed) return;

    try {
      const response = await fetch(`${API_BASE_URL}/categorias.php?id=${id}`, {
        method: 'DELETE'
      });
      const result = await response.json();
      if (result.success) {
        fetchCategories();
      } else {
        showAlert('Aviso','Erro ao excluir categoria');
      }
    } catch (error) {
      console.error('Erro:', error);
    }
  };

  const openNewModal = () => {
    setFormData({ id: null, categoria_id: '', categoria_nome: '', categoria_tipo: '', categoria_status: 'Ativo' });
    setIsModalOpen(true);
  };

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-title">Categorias Financeiras</h1>
          <p className="page-subtitle">Gerencie as categorias de receitas e despesas</p>
        </div>
        <button className="btn-primary" onClick={openNewModal}>
          <Plus size={18} />
          Nova Categoria
        </button>
      </div>

      <div className="card list-card mt-2">
        <div className="table-responsive">
          <table className="data-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Cód.</th>
                <th>Nome</th>
                <th>Tipo</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              {categories.map((cat) => (
                <tr key={cat.id}>
                  <td>#{cat.id}</td>
                  <td>{cat.categoria_id}</td>
                  <td className="font-medium">{cat.categoria_nome}</td>
                  <td>
                    <span className={`badge ${cat.categoria_tipo === 'Receita' ? 'badge-success' : 'badge-danger'}`}>
                      {cat.categoria_tipo}
                    </span>
                  </td>
                  <td>
                    <span className={`badge ${cat.categoria_status === 'Ativo' ? 'badge-warning' : 'badge-danger'}`}>
                      {cat.categoria_status}
                    </span>
                  </td>
                  <td>
                    <div className="action-buttons">
                      <button className="btn-icon" title="Editar" onClick={() => handleEdit(cat)}><Edit2 size={16} /></button>
                      <button className="btn-icon danger" title="Excluir" onClick={() => handleDelete(cat.id)}><Trash2 size={16} /></button>
                    </div>
                  </td>
                </tr>
              ))}
              {categories.length === 0 && (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', padding: '2rem', color: 'var(--text-muted)' }}>
                    Nenhuma categoria registrada.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Modal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        title={formData.id ? "Editar Categoria" : "Nova Categoria"}
      >
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '1.25rem' }}>
          <div className="form-group flex-2">
            <label>Código da Categoria</label>
            <input type="text" name="categoria_id" value={formData.categoria_id} onChange={handleInputChange} placeholder="Ex: CAT01" required className="standard-input" />
          </div>
          <div className="form-group flex-2">
            <label>Nome da Categoria</label>
            <input type="text" name="categoria_nome" value={formData.categoria_nome} onChange={handleInputChange} placeholder="Ex: Manutenção de Equipamentos" required className="standard-input" />
          </div>
          <div className="form-group flex-1">
            <label>Tipo</label>
            <select name="categoria_tipo" value={formData.categoria_tipo} onChange={handleInputChange} className="standard-input" required>
              <option value="">Selecione...</option>
              <option value="Receita">Receita</option>
              <option value="Despesa">Despesa</option>
            </select>
          </div>
          <div className="form-group flex-1">
            <label>Status</label>
            <select name="categoria_status" value={formData.categoria_status} onChange={handleInputChange} className="standard-input" required>
              <option value="Ativo">Ativo</option>
              <option value="Inativo">Inativo</option>
            </select>
          </div>
          <div className="form-actions" style={{ justifyContent: 'flex-end', gap: '1rem', marginTop: '1rem' }}>
            <button type="button" className="btn-outline" onClick={() => setIsModalOpen(false)}>Cancelar</button>
            <button type="submit" className="btn-success">Salvar</button>
          </div>
        </form>
      </Modal>
    </div>
  );
}
